<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- update the ngStyle in case of any performance hit -->
<div
	#container
	class="container dragable-container-zindex"
	[ngClass]="{ 'container-transition': !isDragging && !isResizing }"
	[ngStyle]="{
		width: (width ? width : 'auto') + 'px',
		height: (height ? height : 'auto') + 'px',
		top: y + 'px',
		left: x + 'px',
		zIndex: currentZIndex
	}"
>
	<div *ngIf="resizable" class="resize-handle-container">
		<div
			*ngFor="let direction of directions"
			[ngClass]="'resize-handle resize-handle-' + direction"
			[attr.direction]="direction"
			(mousedown)="resizeStart($event)"
		></div>
	</div>

	<div class="container-content">
		<div #dragArea [hidden]="!(draggable$ | async)" class="drag-area">
			<div *ngIf="showIcon" class="drag-icon">
				<ng-container [ngSwitch]="iconType">
					<i *ngSwitchCase="'move'" class="material-icons">control_camera</i>
					<i *ngSwitchCase="'close'" class="material-icons drag-close" (click)="this.close.emit()">close</i>
				</ng-container>
			</div>
		</div>

		<div [ngClass]="{ 'disable-event': isResizing }" class="content-area">
			<ng-content></ng-content>
		</div>
	</div>
</div>
